'use strict';

class CsvDownloader {
    constructor() {
        'ngInject';

        this.restrict = 'A';
        this.scope = { 
            filename: '=',
            csvData: '='
        }
    }

    link(scope, element) {
        scope.$watch('filename', value => {
            element.attr('download', value);
        });

        scope.$watch('csvData', value => {
            let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            let blob = new Blob([bom, value], {
                type: "text/csv;charset=utf-8"
            });
            let csv = null;
            if(window.navigator.msSaveBlob) {
                element.attr('href', 'javascript: void(0);');
                element.off('click');
                element.on('click', () => {
                    window.navigator.msSaveBlob(blob, scope.filename);
                });
            } else {
                csv = window.URL.createObjectURL(blob);
                element.attr('href', csv);
            }
        });
    }
}

export default angular.module('leptonApp.csvDownloader', [])
    .directive('csvDownloader', [() => new CsvDownloader()])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/csv_downloader/csv_downloader.directive.js